import { t } from '@/plugins/i18n'
import dayjs from 'dayjs'
export const d2cproductColumns: any = [
  {
    label: t('商品类型'),
    prop: 'productType',
    align: 'center',
    slotName: 'productType'
  },
  {
    label: t('商品图片'),
    prop: 'productMainImg',
    align: 'center',
    slotName: 'productMainImg'
  },
  {
    label: t('商品名'),
    prop: 'productName',
    align: 'center',
    slotName: 'productName',
    minWidth: 240
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku',
    minWidth: 300
  },
  {
    label: t('当前单价'),
    prop: 'unitPrice',
    align: 'center',
    slotName: 'unitPrice'
  },
  {
    label: t('处理中'),
    prop: 'pendingStorage',
    align: 'center',
    sortable: 'pendingStorage',
    minWidth: 120,
    slotHeadName: 'pendingStorageHeadD2c'
  },
  {
    label: t('已锁定'),
    prop: 'lockQuantity',
    align: 'center',
    slotName: 'lockQuantity',
    sortable: 'lockQuantity',
    minWidth: 120,
    slotHeadName: 'lockQuantityHeadD2c'

  },
  {
    label: t('可用库存'),
    prop: 'availableQuantity',
    align: 'center',
    slotName: 'availableQuantity',
    sortable: 'availableQuantity',
    minWidth: 130,
    slotHeadName: 'availableQuantityHeadD2c'
  },
  {
    label: t('待处理次品数'),
    prop: 'unableProcessDefectiveProducts',
    align: 'center',
    slotName: 'unableProcessDefectiveProducts',
    sortable: 'unableProcessDefectiveProducts',
    minWidth: 180,
    slotHeadName: 'unableProcessDefectiveProductsHeadD2c'
  }
]

export const b2bProductColumns: any = [
  {
    label: t('图片'),
    prop: 'productMainImg',
    align: 'center',
    fixed: 'left',
    slotName: 'productMainImg',
    className: 'product-gary',
    minWidth: 70
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    slotName: 'customerProductMsku',
    minWidth: 120,
    className: 'product-gary'
  },
  {
    label: t('商品信息'),
    prop: 'productInfo',
    align: 'center',
    // fixed: 'left',
    slotName: 'b2bProductInfo',
    minWidth: 90,
    className: 'product-gary'
  },
  {
    label: t('平台SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'b2bproductSku',
    className: 'product-gary',
    minWidth: 120
  },
  {
    label: t('平台库存'),
    align: 'center',
    prop: 'default',
    className: 'product-father',
    children: [{
      label: t('可用库存'),
      prop: 'availableQuantity',
      slotName: 'availableQuantity',
      slotHeadName: 'availableQuantityHead',
      align: 'center',
      sortable: 'availableQuantity',
      className: 'product-son red-set',
      minWidth: 100
    },
    {
      label: t('处理中'),
      prop: 'pendingStorage',
      align: 'center',
      slotName: 'pendingStorage',
      slotHeadName: 'pendingStorageHead',
      sortable: 'pendingStorage',
      className: 'product-son',
      minWidth: 75
    },
    {
      label: t('已锁定'),
      prop: 'lockQuantity',
      slotName: 'lockQuantity',
      slotHeadName: 'lockQuantityHead',
      align: 'center',
      sortable: 'lockQuantity',
      className: 'product-son',
      minWidth: 100
    },
    {
      label: t('次品'),
      prop: 'unableProcessDefectiveProducts',
      sortable: 'unableProcessDefectiveProducts',
      slotName: 'unableProcessDefectiveProducts',
      slotHeadName: 'unableProcessDefectiveProductsHead',
      align: 'center',
      minWidth: 120,
      className: 'product-son red-set'
    }]
  },
  {
    label: t('Amazon 库存'),
    align: 'center',
    prop: 'default',
    className: 'product-amazon amazon-set',
    children: [
      {
        label: t('Amazon 商品名称'),
        prop: 'amazonProductTitle',
        align: 'center',
        minWidth: 150,
        slotName: 'amazonProductTitle',
        className: 'product-blue amazon-set'
      },
      {
        label: t('可用库存'),
        prop: 'amazonSellQuantity',
        align: 'center',
        className: 'product-blue amazon-set',
        minWidth: 80
      },
      {
        label: t('待入库'),
        prop: 'amazonStockInQuantity',
        align: 'center',
        className: 'product-blue amazon-set blue-set',
        minWidth: 80
      },
      {
        label: t('不可用'),
        prop: 'amazonNotSellQuantity',
        align: 'center',
        className: 'product-blue amazon-set blue-set',
        minWidth: 80
      },
      {
        label: t('Amazon SKU'),
        prop: 'amazonMsku',
        align: 'center',
        className: 'product-blue amazon-set',
        minWidth: 120
      },
      {
        label: t('FNSKU'),
        prop: 'overseaProducSku',
        align: 'center',
        minWidth: 120,
        slotName: 'overseaProducSku',
        className: 'product-blue amazon-set'
      }]
  },
  {
    label: t('商品类型'),
    prop: 'productType',
    align: 'center',
    slotName: 'productType'
  },
  {
    // label: t('预计总库存'),
    prop: 'amazonPredictTotalQuantity',
    align: 'center',
    slotName: 'amazonPredictTotalQuantity',
    slotHeadName: 'amazonPredictTotalQuantityTitle',
    className: 'product-white',
    minWidth: 70,
    fixed: 'right'
  }
  // {
  //   label: t('当前单价'),
  //   prop: 'unitPrice',
  //   align: 'center',
  //   slotName: 'unitPrice',
  //   className: 'product-red'
  // },
  // {
  //   prop: 'commonProduct',
  //   slotHeadName: 'commonProduct',
  //   minWidth: 40,
  //   className: 'product-red'
  // },
  // {
  //   label: t('ASIN'),
  //   prop: 'amazonAsin',
  //   align: 'center',
  //   sortable: 'amazon_bind_status',
  //   className: 'product-blue amazon-set'
  // },
  // {
  //   prop: 'amazonProduct',
  //   slotHeadName: 'amazonProduct',
  //   minWidth: 40,
  //   className: 'product-blue amazon-set'
  // },
  // {
  //   label: t('海外仓sku'),
  //   prop: 'overseaProducSku',
  //   align: 'center',
  //   minWidth: 200,
  //   slotName: 'overseaProducSku'
  // },
]

export const materialsColumns: any = [
  {
    label: t('辅料图片'),
    prop: 'ingredientsImg',
    align: 'center',
    slotName: 'ingredientsImg'
  },
  {
    label: t('辅料名称'),
    prop: 'ingredientsNameJp',
    align: 'center',
    minWidth: 230
  },
  {
    label: t('关联附加项'),
    prop: 'relatedFlag',
    align: 'center',
    slotName: 'relatedFlag',
    minWidth: 180
  },
  {
    label: t('辅料规格'),
    prop: 'materialsStyle',
    align: 'center',
    slotName: 'materialsStyle'
  },
  {
    label: t('辅料skuid'),
    prop: 'ingredientsSku',
    align: 'center',
    minWidth: 250
  },
  {
    label: t('处理中'),
    prop: 'noStockQuantity',
    sortable: 'no_stock_quantity',
    align: 'center',
    minWidth: 100
  },
  {
    label: t('锁定'),
    prop: 'lockQuantity',
    align: 'center',
    sortable: 'lockQuantity',
    slotName: 'lockQuantity',
    minWidth: 120
  },
  {
    prop: 'availableQuantity',
    align: 'center',
    slotName: 'availableQuantity',
    slotHeadName: 'availableQuantityHead',
    sortable: 'availableQuantity',
    minWidth: 120
  }
]

export const productTableConfig = {
  showSelection: true,
  // showExpand: true,
  showHandler: true,
  setHeight: true,
  handlerConfig: {
    width: 260,
    handlerHead: true,
    fixed: false
  }
}
export const b2bproductTableConfig = {
  showSelection: true,
  // showExpand: true,
  showHandler: true,
  setHeight: true,
  rowKey: 'productSku',
  isCheckMemory: true,
  handlerConfig: {
    width: 240,
    handlerHead: true,
    fixed: 'right'
  }
}
export const materialsCanAddCart = (row: any) => dayjs(row.priceExpireTime).valueOf() > dayjs().valueOf() && !row.uploadFlag
export const materialsTableConfig = {
  showSelection: true,
  // showExpand: true,
  showHandler: true,
  setHeight: true,
  handlerConfig: {
    width: 300
  },
  selectable: (row: any) => materialsCanAddCart(row)
}

export const defectiveColums = [
  {
    label: t('序号'),
    prop: 'index',
    align: 'center'
  },
  {
    label: t('次品图'),
    prop: 'defectiveImg',
    align: 'center',
    minWidth: 180,
    slotName: 'defectiveImg'
  },
  {
    label: t('说明'),
    prop: 'defectiveRemark',
    minWidth: 250,
    slotName: 'defectiveRemark'
  }
]

export const defectiveTableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: {
    label: t('处理'),
    minWidth: 120,
    align: 'center'
  }
}

export const productTypeSnum: any = {
  1: t('普通商品'),
  2: t('OEM商品'),
  3: t('组合商品')
}
